import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=0adb999e&scoped=true&lang=html&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=0adb999e&lang=scss&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb999e",
  null
  
)

export default component.exports